export default {"src":"/_next/static/media/footer_x.f1a5d1ee.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};